import React from 'react';

export const appContext = React.createContext({ app: {} });
export const layoutContext = React.createContext({ layout: {} });
